import { DelegateHomeComponent } from './delegate-home/delegate-home.component';
import { FailureComponent } from './failure/failure.component';
import { SuccessComponent } from './success/success.component';

export const DelegateChildRoutes = [
  {
    path: 'success',
    component: SuccessComponent, // another child route component that the router renders
  },
  {
    path: 'failure',
    component: FailureComponent, // another child route component that the router renders
  },
  {
    path: '', // child route path
    component: DelegateHomeComponent, // child route component that the router renders
  },
  {
    path: '**', redirectTo: '/login',
  },
];
